import React from "react";
import { Link } from "react-router-dom";
import { diplomasData } from "../data/data";
import { FaExternalLinkAlt } from "react-icons/fa";

const DiplomasPage = () => {
  return (
    <div
      className="relative w-full min-h-screen bg-cover bg-center flex flex-col items-center"
      style={{
        backgroundImage: `url(/assets/background.jpg)`,
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <header className="relative pt-20 flex flex-col items-center z-10 px-4">
        <h1 className="text-3xl font-bold text-white drop-shadow-md">
          Diplomas & Certifications
        </h1>
      </header>

      <main className="relative z-10 w-full max-w-4xl px-4 mt-12 mb-12 flex flex-col items-center space-y-8">
        {/* Grid of Diplomas */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 w-full">
          {diplomasData.map((diploma, i) => (
            <div
              key={i}
              className="bg-gray-900 rounded-lg shadow p-4 flex flex-col"
              style={{ minHeight: "300px" }}
              /* Optional: Setting a minHeight helps ensure consistent layout */
            >
              <div className="w-full h-48 overflow-hidden flex justify-center items-center bg-gray-800 rounded">
                <img
                  src={diploma.Image}
                  alt={diploma.title}
                  className="object-contain h-full"
                />
              </div>
              <h3 className="text-white font-semibold text-center mt-3 flex-1">
                {diploma.title}
              </h3>
              <div className="mt-3 flex justify-center">
                <a
                  href={diploma.viewLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 py-2 px-3 rounded bg-blue-600 hover:bg-blue-700 text-white transition transform hover:scale-105"
                >
                  <FaExternalLinkAlt />
                  <span>View</span>
                </a>
              </div>
            </div>
          ))}
        </div>

        <Link
          to="/"
          className="py-2 px-4 rounded-lg shadow font-medium text-white bg-blue-600 hover:bg-blue-700 transition transform hover:scale-105"
        >
          Back Home
        </Link>
      </main>
    </div>
  );
};

export default DiplomasPage;
